<div>
  <kl-ai-predictions-share-update (postCreated)="ok()"></kl-ai-predictions-share-update>
</div>
